import moment from "moment";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../../components/atoms/breadcrumb/Breadcrumb";
import Toggle from "../../../components/atoms/button/Toggle";
import Input from "../../../components/atoms/input/Input";
import Loading from "../../../components/atoms/loading/Loading";
import Select from "react-select";
import { TicketRequest } from "../../../apis/ticket/TicketRequest";

const breadcrumbRoute = (
  id: string | undefined,
  variantId: string | undefined
) => {
  return [
    {
      id: 1,
      path: "/home",
      name: "Home",
    },
    {
      id: 2,
      path: "/ticket",
      name: "Ticket",
    },
    {
      id: 3,
      path: `/ticket/${id}/stock-ticket`,
      name: "Stock Ticket",
    },
    {
      id: 4,
      path: `/ticket/${id}/stock-ticket/${variantId}`,
      name: "Detail Ticket",
    },
  ];
};

const StockTicketDetail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { data: dataTicketBundle, isLoading: loadTicketBundle } = useQuery(
    "getTicketById",
    () => TicketRequest.getTicketDetail(params.id)
  );
  const { data, isLoading } = useQuery("getTicketVariantById", () =>
    TicketRequest.getTicketVariantById(params.variantId)
  );
  const [arrDay, setArrDay] = useState<any>([]);

  const goBack = () => {
    navigate(`/ticket/${params.id}/stock-ticket`);
  };

  useEffect(() => {
    if (data) {
      setArrDay(
        Object.entries(data?.claim_time).map(
          (key: any, idx: number) =>
            key[1].enabled && [
              idx === 0
                ? "Sunday"
                : idx === 1
                ? "Monday"
                : idx === 2
                ? "Tuesday"
                : idx === 3
                ? "Wednesday"
                : idx === 4
                ? "Thursday"
                : idx === 5
                ? "Friday"
                : idx === 6
                ? "Saturday"
                : "",
              data?.claim_time[idx],
            ]
        )
      );
    }
  }, [data]);

  return (
    <>
      <main className="">
        <div>
          <Breadcrumb data={breadcrumbRoute(params.id, params.variantId)} />
        </div>
        {isLoading || loadTicketBundle ? (
          <div className="flex justify-center mt-10">
            <Loading />
          </div>
        ) : (
          <section>
            <div className="w-full h-full md:my-14 my-8 md:flex justify-between">
              <div className="md:w-1/3">
                <div className="w-full rounded-md border-2 border-stroke">
                  <div className="md:h-16 h-14 flex items-center md:mx-8 mx-5 bg">
                    <h1 className="font-medium md:text-xl text-sm">
                      Product Images
                    </h1>
                  </div>
                  <hr />

                  <div className="md:m-7 m-5">
                    <div>
                      <h1 className="md:text-base text-sm text-textPrimary">
                        Display Image
                      </h1>
                      <div className="flex justify-center items-center">
                        <img
                          src={dataTicketBundle?.preview_image_path}
                          alt="-"
                          className="w-1/3 rounded-md shadow-md"
                        />
                      </div>
                    </div>

                    {dataTicketBundle.display_media_type === "image" ? (
                      <div className="mt-10 text-textPrimary">
                        <h1 className="md:text-base text-sm">Upload Images</h1>
                        <div className="flex justify-center items-center">
                          <img
                            src={dataTicketBundle?.display_image_path}
                            alt="-"
                            className="w-2/5 rounded-md shadow-md"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="mt-10 text-textPrimary">
                        <div className="flex justify-center">
                          <video
                            controls
                            src={dataTicketBundle?.display_video_path}
                            className="w-2/5 rounded-md shadow-md"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="w-full my-10 rounded-md border-2 border-stroke">
                  <div className="items-center md:m-7 m-5">
                    <h1 className="md:text-base text-sm">Detail Images</h1>
                    <h1 className="text-xs font-rom text-textPrimary mt-1">
                      Note: You can add your size chart or detail type of your
                      product
                    </h1>
                  </div>
                  <hr />
                  <div className="md:m-7 m-5">
                    <div className="grid grid-cols-4 gap-3">
                      {dataTicketBundle?.description_image_paths.map(
                        (el: any) => (
                          <img
                            src={el?.image_path}
                            alt="-"
                            className="w-full rounded-md shadow-md"
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Variant information */}
              <div className="md:w-custom w-full md:mt-0 mt-10 h-full">
                <div className="rounded-md rounded-b-none border-2 border-stroke">
                  <div className="md:h-16 h-14 flex items-center justify-between md:mx-8 mx-5">
                    <h1 className="font-medium md:text-xl text-sm">
                      Variant Information
                    </h1>
                  </div>
                  <hr />
                  <div className="md:m-8 m-5">
                    <div className="md:flex">
                      <div className="md:w-1/2">
                        <h1 className="md:text-base text-sm text-textPrimary">
                          Variant
                        </h1>
                        <Input
                          disable
                          type={"text"}
                          name={"label"}
                          value={data.label}
                          placeholder={"Place holder"}
                        />
                      </div>
                      <div className="md:w-1/2 md:ml-8 md:mt-0 mt-2">
                        <h1 className="md:text-base text-sm text-textPrimary">
                          Stock
                        </h1>
                        <Input
                          disable
                          type={"number"}
                          name={"stock"}
                          value={data.stock}
                          placeholder={"Place holder"}
                        />
                      </div>
                    </div>

                    <div className="md:flex my-3">
                      <div className="md:w-1/2">
                        <h1 className="md:text-base text-sm text-textPrimary">
                          Product Price
                        </h1>
                        <Input
                          disable
                          type={"number"}
                          name={"price"}
                          value={data.price}
                          placeholder={"Place holder"}
                        />
                      </div>
                      <div className="md:w-1/2 md:ml-8 md:mt-0 mt-2">
                        <h1 className="md:text-base text-sm text-textPrimary">
                          Limit Using Ticket
                        </h1>
                        <Input
                          disable
                          type={"number"}
                          name={"usage_slot"}
                          value={data.usage_slot}
                          placeholder={"Place holder"}
                        />
                      </div>
                    </div>

                    <div className="md:flex my-3">
                      <div className="md:w-1/2">
                        <h1 className="md:text-base text-sm text-textPrimary">
                          Limited Product
                        </h1>
                        <div className="md:mt-5 mt-2 flex">
                          <Toggle
                            input={data.is_limited}
                            handleClick={() => {}}
                            disabled={true}
                          />
                          <h1 className="font-rom md:text-base text-sm ml-4 text-textPrimary">
                            {data.is_limited ? "Enable" : "Disable"}
                          </h1>
                        </div>
                      </div>
                      <div className="md:w-1/2 md:ml-8  md:mt-0 mt-5">
                        <h1 className="md:text-base text-sm text-textPrimary">
                          Limit / user
                        </h1>
                        <Input
                          disable
                          type={"number"}
                          name={"limit_per_user"}
                          value={data.limit_per_user}
                          placeholder={"Place holder"}
                        />
                      </div>
                    </div>

                    <div className="md:flex my-3">
                      <div className="md:w-1/2">
                        <h1 className="md:text-base text-sm text-textPrimary">
                          Selling Date & Time
                        </h1>
                        <h1 className="md:text-sm text-xs font-rom text-textPrimary">
                          If it is not activated, the ticket has no sales
                          deadline
                        </h1>
                        <div className="flex mt-2">
                          <Toggle
                            input={data.selling_time_enabled}
                            handleClick={() => {}}
                            disabled={true}
                          />
                          <h1 className="font-rom md:text-base text-sm ml-4 text-textPrimary">
                            {data.selling_time_enabled ? "Enable" : "Disable"}
                          </h1>
                        </div>
                      </div>
                      <div className="md:w-1/2 md:ml-8  md:mt-0 mt-5">
                        <div className="w-full">
                          <h1 className="md:text-base text-sm text-textPrimary">
                            From
                          </h1>
                          <Input
                            disable
                            type={"datetime-local"}
                            name={"selling_start_time"}
                            value={moment(data.selling_start_time).format(
                              "YYYY-MM-DDTHH:mm"
                            )}
                            placeholder={"Place holder"}
                          />
                        </div>
                        <div className="w-full  md:mt-0 mt-2">
                          <h1 className="md:text-base text-sm text-textPrimary">
                            To
                          </h1>
                          <Input
                            disable
                            type={"datetime-local"}
                            name={"selling_end_time"}
                            value={moment(data.selling_end_time).format(
                              "YYYY-MM-DDTHH:mm"
                            )}
                            placeholder={"Place holder"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="md:flex my-3">
                      <div className="md:w-1/2">
                        <h1 className="md:text-base text-sm text-textPrimary">
                          Valid Date & Time
                        </h1>
                        <h1 className="md:text-sm text-xs font-rom text-textPrimary">
                          If it is not activated, the ticket has no usage time
                          limit
                        </h1>
                        <div className="flex mt-2">
                          <Toggle
                            input={!data.valid_time_indefinite}
                            handleClick={() => {}}
                            disabled={true}
                          />
                          <h1 className="font-rom md:text-base text-sm ml-4 text-textPrimary">
                            {data.valid_time_indefinite ? "Disable" : "Enable"}
                          </h1>
                        </div>
                      </div>

                      <div className="md:ml-8 md:w-1/2 md:mt-0 mt-5">
                        <div>
                          <h1 className="md:text-base text-sm text-textPrimary">
                            Option
                          </h1>
                          <Select
                            isDisabled={true}
                            value={{
                              label: data.valid_time_type,
                              value: data.valid_time_type,
                            }}
                            className="font-rom text-sm mt-3"
                          />
                        </div>
                        {data.valid_time_type === "scheduled" ? (
                          <div className="my-5">
                            <div className="w-full">
                              <h1 className="md:text-base text-sm text-textPrimary">
                                From
                              </h1>
                              <Input
                                disable
                                type={"datetime-local"}
                                name={"valid_time_from"}
                                value={moment(data.valid_time_from).format(
                                  "YYYY-MM-DDTHH:mm"
                                )}
                                placeholder={"Place holder"}
                              />
                            </div>
                            <div className="w-full md:mt-0 mt-2">
                              <h1 className="md:text-base text-sm text-textPrimary">
                                To
                              </h1>
                              <Input
                                disable
                                type={"datetime-local"}
                                name={"valid_time_until"}
                                value={moment(data.valid_time_until).format(
                                  "YYYY-MM-DDTHH:mm"
                                )}
                                placeholder={"Place holder"}
                              />
                            </div>
                          </div>
                        ) : data?.valid_time_type === "interval_day" ? (
                          <div className="w-full my-3">
                            <h1 className="md:text-base text-sm text-textPrimary">
                              Period
                            </h1>
                            <Input
                              disable
                              type={"number"}
                              name={"valid_time_interval"}
                              value={data.valid_time_interval}
                              placeholder={"Place holder"}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="my-3 w-full">
                      <div className="flex items-start justify-between">
                        <div className="md:w-1/2">
                          <h1 className="md:text-base text-sm text-textPrimary">
                            Selling Day & Hours
                          </h1>
                          <h1 className="md:text-sm text-xs font-rom text-textPrimary">
                            If it is not activated, the ticket has no usage time
                            limit
                          </h1>
                        </div>
                      </div>

                      <div className="grid xl:grid-cols-7 grid-cols-3 md:gap-3 gap-2 my-5">
                        <div className="md:h-24 h-20 flex items-center justify-center border rounded-md border-stroke">
                          <h1 className="md:text-base text-sm">Monday</h1>
                        </div>
                        <div className="md:h-24 h-20 flex items-center justify-center border rounded-md border-stroke">
                          <h1 className="md:text-base text-sm">Tuesday</h1>
                        </div>
                        <div className="md:h-24 h-20 flex items-center justify-center border rounded-md border-stroke">
                          <h1 className="md:text-base text-sm">Wednesday</h1>
                        </div>
                        <div className="md:h-24 h-20 flex items-center justify-center border rounded-md border-stroke">
                          <h1 className="md:text-base text-sm">Thursday</h1>
                        </div>
                        <div className="md:h-24 h-20 flex items-center justify-center border rounded-md border-stroke">
                          <h1 className="md:text-base text-sm">Friday</h1>
                        </div>
                        <div className="md:h-24 h-20 flex items-center justify-center border rounded-md border-stroke">
                          <h1 className="md:text-base text-sm">Saturday</h1>
                        </div>
                        <div className="md:h-24 h-20 flex items-center justify-center border rounded-md border-stroke">
                          <h1 className="md:text-base text-sm">Sunday</h1>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="md:m-8 m-5 md:text-lg text-base">
                    <h1>Summary</h1>
                  </div>
                  <hr />
                  <div className="md:m-8 m-5 font-rom md:text-base text-sm">
                    {arrDay.filter(Boolean).map((el: any) => (
                      <h1>
                        {el[0]} :{" "}
                        {moment("2200-03-13 " + el[1]?.start).format("HH:mm a")}{" "}
                        - {moment("2200-03-13 " + el[1]?.end).format("HH:mm a")}
                      </h1>
                    ))}
                  </div>
                  <hr />
                  <div className="md:m-8 m-5">
                    <div className="md:text-lg text-base">
                      <h1 className="text-textPrimary md:text-base text-sm">
                        Description
                      </h1>
                      <textarea
                        name="description"
                        rows={5}
                        value={data.description}
                        placeholder="Feature: Bicycle Intelligent Light Sensitive Light
                          
                 Note: When the blue light is on, it enters the induction mode, and with changes in the brightness around the lamp will change 
                 
                 This light is placed on the bicycle handlebar to provide light to the front of the road, when cycling at night or in the dark. Useful in foggy conditions where visibility is very limited."
                        className="border border-stroke w-full mt-2 rounded-md font-rom p-3 text-sm focus:ring-1 focus:outline-none"
                      ></textarea>
                    </div>
                    <div className="my-5 md:text-lg text-base">
                      <h1 className="text-textPrimary md:text-base text-sm">
                        How to use
                      </h1>
                      <textarea
                        value={data.how_to}
                        placeholder="- Open the QR.

                   - Show for our customer service.
                   
                   - Redeem a ticket."
                        cols={30}
                        rows={5}
                        name="how_to"
                        className="border border-stroke w-full mt-2 rounded-md font-rom p-3 text-sm focus:ring-1 focus:outline-none"
                      ></textarea>
                    </div>
                    <div className="my-5 md:text-lg text-base">
                      <div className="flex justify-between">
                        <h1 className="text-textPrimary md:text-base text-sm">
                          Term & Conditions
                        </h1>
                        <h1 className="text-primary cursor-pointer md:text-base text-sm">
                          Auto Generate
                        </h1>
                      </div>

                      {data?.tnc?.length > 0 &&
                        data.tnc.map((el: string, i: number) => (
                          <div className="flex">
                            <Input
                              type={"text"}
                              name={"valid_time_until"}
                              placeholder={"Place holder"}
                              value={el}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </main>
    </>
  );
};

export default StockTicketDetail;
